<div class="main-container">
  <div class="bg-container">
    <div class="logo-header">
      <img src="../../../../assets/images/brijjworks_logo_primary.svg" alt="" />
    </div>
    <!-- Update Password Section -->
    <div class="center-container my-auto">
      <div class="pass-content">
        <div class="reset-head text-center">
          <div class="form-head text-center">
            <h5 class="text-center m-0 p-0">Complete Account Setup</h5>
          </div>
        </div>
        <div
          class="error-msg-container"
          *ngIf="errorMsgType == 'passLimit' || errorMsgType == 'notSame'"
        >
          <img src="../../../../assets/images/Info.svg" alt="" />
          <span id="invalidInput" class="error-msg">
            {{
              errorMsgType == 'passLimit'
                ? 'Use a strong password with at least 8
            characters.'
                : 'New Password and Confirm Password must be the same!'
            }}
          </span>
        </div>
        <div class="reset-pass-input-wrapper">
          <div class="mb-2 pb-1 mt-4 entre-value">
            <label for="username" class="input-label">Username</label>
            <div class="input-wrapper">
              <img src="../../../../assets/images/ic-email.svg" />
              <input
                type="text"
                class="form-control form-input"
                autocomplete="off"
                name="email"
                (keyup)="getBtnStatus()"
                [(ngModel)]="loginInfo.userName"
                placeholder="Enter username"
              />
            </div>
          </div>
          <div class="mb-2 entre-value">
            <label for="username" class="input-label">New Password</label>
            <div class="input-wrapper">
              <img src="../../../../assets/images/ic-password.svg" />
              <input
                type="text"
                class="form-control form-input"
                autocomplete="new-password"
                name="newPass"
                (keyup)="getBtnStatus()"
                [(ngModel)]="passWord"
                [type]="showNewPass ? 'text' : 'password'"
                placeholder="Enter password"
              />
              <button class="btn p-0 border-0" (click)="toggleNewPass()" [disabled]="!passWord">
                <img
                  class="c-pt"
                  [src]="
                    showNewPass
                      ? '../../../../assets/images/ic-pass_show.svg'
                      : '../../../../assets/images/ic-pass_hide.svg'
                  "
                />
              </button>
            </div>
          </div>
          <div class="mb-2 entre-value">
            <label for="username" class="input-label">Confirm Password</label>
            <div class="input-wrapper">
              <img src="../../../../assets/images/ic-password.svg" />
              <input
                type="text"
                class="form-control form-input"
                autocomplete="new-password"
                name="confirmPass"
                (keyup)="getBtnStatus()"
                [(ngModel)]="conFirmPassWord"
                [type]="togglecpass ? 'text' : 'password'"
                placeholder="Confirm password"
              />
              <button
                class="btn p-0 border-0"
                (click)="toggleCPasswordVisibility()"
                [disabled]="!conFirmPassWord"
              >
                <img
                  class="c-pt"
                  [src]="
                    togglecpass
                      ? '../../../../assets/images/ic-pass_show.svg'
                      : '../../../../assets/images/ic-pass_hide.svg'
                  "
                />
              </button>
            </div>
          </div>
        </div>
        <div class="custom-footer mt-3">
          <button class="btn" (click)="resetPasswordValues()">Clear</button>
          <button class="btn w-100 dis-btn" *ngIf="!isAbleToSet">Set Password</button>
          <button
            class="btn w-100"
            (click)="managePassword()"
            *ngIf="isAbleToSet"
            style="background-color: rgb(23, 95, 145); color: white"
          >
            Set Password
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
